module.exports = false;


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1